import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import withWidth, { isWidthDown } from '@material-ui/core/withWidth';

import {
  AULoadingManager,
  AUMainContainer,
  AUNavBar,
  AUNotificationHub,
  AUSideBar,
  AUValidateAccessProduct,
  FunctionUtils,
  PRODUCT_IDS,
} from '@assertiva/assertiva-ui';
import history from '../../history';
import routes from '../../routes';

const MainLayout = ({ children, width, path }) => {
  const isMobile = isWidthDown('sm', width);
  const [openSidebar, setOpenSidebar] = React.useState(false);
  const [isLinearLoading, setLinearLoading] = React.useState(false);

  const handleSidebar = () => setOpenSidebar(!openSidebar);

  useEffect(() => {
    const loadingSub = AULoadingManager.subscribe(({ isLoading, name }) => {
      if (name === 'LINEAR') {
        setLinearLoading(isLoading);
      }
    });

    return () => {
      AULoadingManager.unsubscribe(loadingSub);
    };
  }, []);

  return (
    <div>
      <AUNavBar
        handleClickIconButton={handleSidebar}
        isSidebarOpen={openSidebar}
        handleClickLogoIcon={() => history.push('/dashboard')}
        handleAfterLogout={() => {
          FunctionUtils.clearLocalStorage();
          history.push('/');
        }}
        loading={isLinearLoading}
      />

      <AUSideBar
        routes={routes}
        path={path}
        open={openSidebar}
        onClose={handleSidebar}
        onOpen={handleSidebar}
        variant={isMobile ? 'temporary' : 'permanent'}
        width={width}
        menuProps={{
          listItemProps: { showCollapseIcon: false },
        }}
      />

      <AUMainContainer isSideBarOpen={openSidebar}>
        <AUValidateAccessProduct productId={PRODUCT_IDS.GEOTIMIZE}>
          <AUNotificationHub productId={PRODUCT_IDS.GEOTIMIZE} />
          {children}
        </AUValidateAccessProduct>
      </AUMainContainer>
    </div>
  );
};

MainLayout.propTypes = {
  children: PropTypes.node.isRequired,
  width: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']).isRequired,
  path: PropTypes.string,
};

MainLayout.defaultProps = {
  path: '',
};

export default withWidth()(MainLayout);
